import React, { useId, useState } from 'react';

function Accordion({
  children,
  className = '',
  defaultOpen = false,
  helper,
  title,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const generatedId = useId();
  const contentId = `custom-accordion-content-${generatedId}`;

  return (
    <section className={['custom-accordion', open ? 'open' : '', className].filter(Boolean).join(' ')}>
      <button
        type="button"
        className="custom-accordion__trigger"
        aria-expanded={open}
        aria-controls={contentId}
        onClick={() => setOpen((current) => !current)}
      >
        <span>
          <strong>{title}</strong>
          {helper && <small>{helper}</small>}
        </span>
        <span className="custom-accordion__chevron" aria-hidden="true">›</span>
      </button>
      <div id={contentId} className="custom-accordion__content" hidden={!open}>
        {children}
      </div>
    </section>
  );
}

export default Accordion;
